import { AuthProvider as KitbagAuthProvider } from '@statsbomb/kitbag-auth';
import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router-dom';

export const {
  REACT_APP_AUTH0_AUDIENCE = 'https://internal.statsbomb.com/',
  REACT_APP_AUTH_CLIENT_ID = 'IAejy0bjCKBUTqUZ3Pl3ABe8kMVP1OYL',
  REACT_APP_AUTH_ISSUER = 'auth.statsbomb.com',
  REACT_APP_AUTH_ROLE_COLLECTOR = 'Video Collector',
  REACT_APP_AUTH_ROLE_CUSTOMER = 'Video Customer',
  REACT_APP_AUTH_ROLE_OPERATOR = 'Video Operator',
  REACT_APP_AUTH_ROLE_ANALYST = 'Video Analyst',
  REACT_APP_AUTH0_VIDEO_SERVICE_SCOPE = 'video:all',
  REACT_APP_AUTH_CACHE_LOCATION,
  REACT_APP_REALTIME_GRAPHQL_URL,
  REACT_APP_GRAPHQL_URL,
  REACT_APP_VIDEO_SERVICE_URL,
} = process.env;

export const CLAIMS_URI = 'https://video.statsbomb.com/jwt/claims';

export const AUTH0_HEADER_PREFIX = 'Bearer ';

function AuthProvider({ children }) {
  const history = useHistory();

  const onRedirectCallback = (appState) => {
    if (appState?.returnTo) {
      history.push(appState?.returnTo);
    }
  };

  return (
    <KitbagAuthProvider
      providerOptions={{
        authorizationParams: {
          audience: REACT_APP_AUTH0_AUDIENCE,
          redirect_uri: window.location.origin,
        },
        cacheLocation: REACT_APP_AUTH_CACHE_LOCATION || undefined,
        clientId: REACT_APP_AUTH_CLIENT_ID,
        domain: REACT_APP_AUTH_ISSUER,
        onRedirectCallback,
      }}
    >
      {children}
    </KitbagAuthProvider>
  );
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthProvider;
